import React, { useEffect, useState } from 'react';
import ClientPortalLayout from './Layout';
import { clientPortalFetch } from './api';
import { StatusPill, formatDate } from './Dashboard';

const NAVY = '#0f1f45';

function TasksInner() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    clientPortalFetch('/tasks').then(setTasks).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = filter === 'all' ? tasks : tasks.filter((t) => t.status === filter);
  const statuses = ['all', ...Array.from(new Set(tasks.map((t) => t.status)))];

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
        {statuses.map((s) => (
          <button key={s} onClick={() => setFilter(s)} style={{
            border: '1px solid #e5e7eb', borderRadius: 999, padding: '6px 14px', fontSize: 12,
            fontWeight: 500, cursor: 'pointer', textTransform: 'capitalize',
            background: filter === s ? NAVY : '#fff', color: filter === s ? '#fff' : '#374151',
          }}>
            {s.replace(/_/g, ' ')}
          </button>
        ))}
      </div>

      {loading && <p style={{ color: '#9ca3af', fontSize: 13 }}>Loading…</p>}
      {!loading && filtered.length === 0 && <p style={{ color: '#9ca3af', fontSize: 13 }}>No tasks found.</p>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {filtered.map((t) => (
          <div key={t.id} style={{
            background: '#fff', borderRadius: 12, padding: '16px 18px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap',
          }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{t.title}</div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>
                {t.task_number}
                {t.due_date ? ` · Due ${formatDate(t.due_date)}` : ''}
                {t.completed_date ? ` · Completed ${formatDate(t.completed_date)}` : ''}
              </div>
            </div>
            <StatusPill status={t.status} />
          </div>
        ))}
      </div>
    </div>
  );
}

function Tasks() {
  return <ClientPortalLayout title="Tasks"><TasksInner /></ClientPortalLayout>;
}

export default Tasks;
